import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { BusinessState } from '@state/business';
import { ICON } from '@core/util/icon';

@Component({
	selector: 'app-confirm-chicago-firm-modal',
	templateUrl: './confirm-firm-modal.component.html',
	standalone: false,
})
export class ConfirmFirmModalComponent implements OnInit {
	public ICON = ICON;
	public lawFirmName = '';
	public editing = false;
	public confirmFirmName = false;

	@SelectSnapshot(BusinessState.businessName) lawfirm: string;
	@SelectSnapshot(BusinessState.chicagoFirmName) chicagoLawfirm: string;

	constructor(private dialogRef: MatDialogRef<ConfirmFirmModalComponent>) {}

	ngOnInit(): void {
		this.lawFirmName = this.chicagoLawfirm || this.lawfirm;
	}

	toggleEdit(): void {
		this.editing = !this.editing;
		this.confirmFirmName = false;
	}

	save(): void {
		this.editing = false;
	}

	connect(): void {
		this.dialogRef.close(this.lawFirmName);
	}

	cancel(): void {
		this.dialogRef.close('');
	}
}
